// extracted by mini-css-extract-plugin
export default {"spin":"products_spin__9vPV5"};